import { useState } from 'react'
import { getSenderUrl, getSignerUrl, getUserEnvelopes } from '../services/envelopes'
import { useAuth } from '../modules/auth'

const useGetEnvelopes = (): {
    fetchEnvelopes: (itemsPerPage: number, offset: number, status?: string, docType?: string) => void
    envelopes: null | any
    loading: boolean
    setEnvelopes: any
    fetchEnvelope: any
    fetchSignerEnvelope: any
    envelope: any
    loadingEnvelope: boolean
} => {
    const [envelopes, setEnvelopes] = useState<null | any>(null)
    const [loading, setLoading] = useState<boolean>(false)
    const { currentUser } = useAuth()
    const { hasOrganization } = currentUser
      const { isInvitedByOrganization } =currentUser?.data.user


    const [envelope, setEnvelope] = useState<null | string>(null)
    const [loadingEnvelope, setLoadingEnvelope] = useState<boolean>(false)

    const fetchEnvelopes = async (itemsPerPage: number, offset: number, status?: string, docType?: string) => {
        setLoading(true)
        try {
            const res = await getUserEnvelopes(itemsPerPage, offset, status, docType)
            setEnvelopes(res.data.data)
        } catch (error) {
            setEnvelopes(null)
        } finally {
            setLoading(false)
        }

    }

    const fetchEnvelope = async (envelopeId: string) => {
        setLoadingEnvelope(true)
        try {
            const payload = {
                envelopeId,
                returnUrl: `https://${window.location.hostname}/integrations`
            }
            const res = await getSenderUrl(payload)
            setEnvelope(res.data.data)
        } catch (error: any) {
            if (error?.response?.data?.message) {
                setEnvelope(error?.response?.data?.message)
            } else {
                setEnvelope(null)
            }
        } finally {
            setLoadingEnvelope(false)
        }

    }
    const fetchSignerEnvelope = async (envelopeId: string, email: string) => {
        setLoadingEnvelope(true)
        try {
            const payload = {
                envelopeId,
                returnUrl: `https://${window.location.hostname}/integrations`,
                recipientEmail: email,
                accountType: (hasOrganization || isInvitedByOrganization) ?'ORGANIZATION':'INDIVIDUAL',
            }
            const res = await getSignerUrl(payload)
            setEnvelope(res.data.data)
        } catch (error: any) {
            if (error?.response?.data?.message) {
                setEnvelope(error?.response?.data?.message)
            } else {
                setEnvelope(null)
            }
        } finally {
            setLoadingEnvelope(false)
        }

    }
    return { envelopes, loading, fetchEnvelopes, setEnvelopes, fetchEnvelope, envelope, loadingEnvelope, fetchSignerEnvelope }
}

export default useGetEnvelopes